const FeatureHeader = ({ title, description } : { title: string, description: string }) => {
    return <div className='feature-header'>
        <span className="title">{title}</span>
        <span className="description">{description}</span>
    </div>
}

export default FeatureHeader;